/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/common/money';
import '../../connect/v2/catalog/resources/enums';
import '../../connect/v2/common/measurement_units';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "stockorders": {
        "nested": {
          "model": {
            "nested": {
              "TransferOrder": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transferOrderId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "orderNumber": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "state": {
                    "type": ".squareup.stockorders.model.TransferOrder.TransferOrderState",
                    "id": 4,
                    "rule": "optional"
                  },
                  "sourceLocation": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "destinationLocation": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "trackingNumber": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "expectedOnUnixMillis": {
                    "type": "int64",
                    "id": 8,
                    "rule": "optional"
                  },
                  "updatedOn": {
                    "type": "int64",
                    "id": 9,
                    "rule": "optional"
                  },
                  "fee": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 10,
                    "rule": "optional"
                  },
                  "feeTax": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 11,
                    "rule": "optional"
                  },
                  "hasPendingItems": {
                    "type": "bool",
                    "id": 12,
                    "rule": "optional"
                  },
                  "notes": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "numberOfLines": {
                    "type": "int32",
                    "id": 14,
                    "rule": "optional"
                  },
                  "totalPendingItems": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "int64",
                    "id": 17,
                    "rule": "optional"
                  },
                  "createdByEmploymentToken": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  },
                  "totalItemCount": {
                    "type": "string",
                    "id": 19,
                    "rule": "optional"
                  },
                  "completedAt": {
                    "type": "int64",
                    "id": 20,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "TransferOrderState": {
                    "values": {
                      "TRANSFER_ORDER_STATE_DO_NOT_USE": 0,
                      "DRAFT": 1,
                      "STARTED": 2,
                      "PARTIALLY_RECEIVED": 3,
                      "COMPLETED": 4,
                      "CANCELED": 5
                    }
                  }
                }
              },
              "TransferOrderLine": {
                "fields": {
                  "transferOrderLineId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "itemVariation": {
                    "type": ".squareup.stockorders.model.ItemVariation",
                    "id": 2,
                    "rule": "optional"
                  },
                  "quantityReceived": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "quantityCanceled": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "quantityDamaged": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "quantityPending": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "totalQuantityOrdered": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "ItemVariation": {
                "fields": {
                  "itemToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "itemName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "variationToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "variationName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "image": {
                    "type": ".squareup.stockorders.model.ItemVariation.Image",
                    "id": 5,
                    "rule": "optional"
                  },
                  "sku": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "gtin": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "currencyCode": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 9,
                    "rule": "optional"
                  },
                  "measurementUnit": {
                    "type": ".squareup.stockorders.model.ItemVariation.MeasurementUnit",
                    "id": 10,
                    "rule": "optional"
                  },
                  "vendorCode": {
                    "type": "string",
                    "id": 11,
                    "rule": "repeated"
                  },
                  "pricingType": {
                    "type": ".squareup.connect.v2.merchant_catalog.resources.CatalogPricingType",
                    "id": 12,
                    "rule": "optional"
                  },
                  "priceMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 13,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Image": {
                    "fields": {
                      "url": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "abbreviation": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "hexColor": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "MeasurementUnit": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "precision": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      },
                      "measurementUnit": {
                        "type": ".squareup.connect.v2.common.MeasurementUnit",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.stockorders?.nested?.model?.nested?.TransferOrder && !$root.nested?.squareup?.nested?.stockorders?.nested?.model?.nested?.TransferOrder?.nested?.TransferOrderState && !$root.nested?.squareup?.nested?.stockorders?.nested?.model?.nested?.TransferOrderLine && !$root.nested?.squareup?.nested?.stockorders?.nested?.model?.nested?.ItemVariation && !$root.nested?.squareup?.nested?.stockorders?.nested?.model?.nested?.ItemVariation?.nested?.Image && !$root.nested?.squareup?.nested?.stockorders?.nested?.model?.nested?.ItemVariation?.nested?.MeasurementUnit) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE TransferOrder @ squareup/stockorders/model/model.proto at 13:1
 */
export const TransferOrder = $root.lookupType('squareup.stockorders.model.TransferOrder');
fixType(TransferOrder);
Builder.createAndAttachToType(TransferOrder);
/**
 * Definition of the possible transfer order states.
 *
 * SOURCE TransferOrderState @ squareup/stockorders/model/model.proto at 24:3
 */
TransferOrder.TransferOrderState = $root.lookupEnum('squareup.stockorders.model.TransferOrder.TransferOrderState').values;
/**
 * SOURCE TransferOrderLine @ squareup/stockorders/model/model.proto at 82:1
 */
export const TransferOrderLine = $root.lookupType('squareup.stockorders.model.TransferOrderLine');
fixType(TransferOrderLine);
Builder.createAndAttachToType(TransferOrderLine);
/**
 * Contains information about the item variation counted in stock order lines. *
 *
 * SOURCE ItemVariation @ squareup/stockorders/model/model.proto at 106:1
 */
export const ItemVariation = $root.lookupType('squareup.stockorders.model.ItemVariation');
fixType(ItemVariation);
Builder.createAndAttachToType(ItemVariation);
/**
 * SOURCE Image @ squareup/stockorders/model/model.proto at 107:3
 */
ItemVariation.Image = $root.lookupType('squareup.stockorders.model.ItemVariation.Image');
fixType(ItemVariation.Image);
Builder.createAndAttachToType(ItemVariation.Image);
/**
 * SOURCE MeasurementUnit @ squareup/stockorders/model/model.proto at 113:3
 */
ItemVariation.MeasurementUnit = $root.lookupType('squareup.stockorders.model.ItemVariation.MeasurementUnit');
fixType(ItemVariation.MeasurementUnit);
Builder.createAndAttachToType(ItemVariation.MeasurementUnit);